<template>
  <WithTitle :title="$t('tab.instructions')">
    <ProductInstructions v-if="instructions.length" :instructions="instructions" />
    <Loader v-else without-opacity is-loading />
  </WithTitle>
</template>

<script>
import { mapState } from 'vuex'
import WithTitle from '../layouts/WithTitle'
import ProductInstructions from '../../../components/product/product-page/ProductInstructions'
import Loader from '@/components/helpers/Loader'

export default {
  name: 'ProductInstructionsTab',
  components: {
    Loader,
    ProductInstructions,
    WithTitle
  },
  computed: {
    ...mapState({
      instructions: state => state.productInfo.productInfo.instructions
    })
  }
}
</script>

<style scoped>

</style>
